module.exports = __webpack_public_path__ + "img/logo.a890a96d.png";